/* @jsx h */
import { defineComponent, h } from "vue";
import { useLocalization } from "@lemmonhq/uikit";
import type { AuthenticationMode } from "./types";

const TERMS_URL = "https://lemmonpos.ch/t-c";
const PRIVACY_URL = "https://lemmonpos.ch/privacy-policy";

type TermsNoticeProps = {
  mode: AuthenticationMode;
};

export const TermsNotice = defineComponent<TermsNoticeProps>({
  name: "TermsNotice",
  props: ["mode"],
  setup(props) {
    const { t } = useLocalization();

    return () => (
      <p class="text-xs">
        {props.mode === "signup"
          ? t("customer.account.terms_notice_prefix")
          : t("customer.account.terms_notice_prefix_signin")}{" "}
        <a
          href={TERMS_URL}
          target="_blank"
          rel="noopener noreferrer"
          class="link link-hover font-medium text-base-content"
        >
          {t("customer.account.terms_notice_terms")}
        </a>{" "}
        {t("customer.account.terms_notice_and")}{" "}
        <a
          href={PRIVACY_URL}
          target="_blank"
          rel="noopener noreferrer"
          class="link link-hover font-medium text-base-content"
        >
          {t("customer.account.terms_notice_privacy")}
        </a>
        {t("customer.account.terms_notice_suffix")}
      </p>
    );
  },
});
